import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
@Component({
  selector: 'app-steel-source-options-edit',
  templateUrl: './steel-source-options-edit.component.html',
  styleUrls: ['./steel-source-options-edit.component.css']
})
export class SteelSourceOptionsEditComponent implements OnInit {
steelSourceOptionForm: FormGroup;
  isSubmitting = false;
  errors: any = {};  
  steelSourceOptionId!: number;
  categories: any[] = [];
  selectedCountries: string[] = [];
  availableCountries: string[] = [];


  constructor(
    private steelSourceOptionService: VesselCalculationInventoryService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.steelSourceOptionForm = this.fb.group({
      title: ['', Validators.required],  
      coefficient: ['', Validators.required], 
      percentage: ['', Validators.required], 
      scenarioCategoryId: [null, Validators.required],
      description: [''],
      countryInput: ['']
    });
  }

  ngOnInit(): void {
    this.steelSourceOptionId = Number(this.route.snapshot.paramMap.get('id'));
    if (this.steelSourceOptionId) {
      this.loadSteelSourceOption();
    }
    this.loadCategoriesForSteelSource();  
    this.loadAvailableCountries();

  }
  loadAvailableCountries(): void {
    this.steelSourceOptionService.getAvailableCountries().subscribe(
      (response) => {
        this.availableCountries = response;
      },
      (error) => {
        console.error('Error fetching available countries:', error);
      }
    );
  }
  loadCategoriesForSteelSource(): void {
    this.steelSourceOptionService.getCategoriesForSteelSource().subscribe(response => {
      this.categories = response; 
    }, error => {
      console.error('Error fetching categories for Steel Source:', error);
    });
  }

  loadSteelSourceOption(): void {
    this.steelSourceOptionService.getSteelSourceOptionById(this.steelSourceOptionId).subscribe(
      (data) => {
        this.steelSourceOptionForm.patchValue(data);
        this.selectedCountries = data.countries ? data.countries.split(', ') : [];  
      },
      (error) => {
        this.toastr.error('Failed to load steel source option.');
      }
    );
  }

  addCountry(): void {
    const country = this.steelSourceOptionForm.get('countryInput')?.value.trim();
    if (country && !this.selectedCountries.includes(country)) {
      this.selectedCountries.push(country);
      this.steelSourceOptionForm.get('countryInput')?.setValue('');
    }
  }

  removeCountry(country: string): void {
    this.selectedCountries = this.selectedCountries.filter(c => c !== country);
  }

  updateSteelSourceOption(): void {
    if (this.isSubmitting) return;

    this.isSubmitting = true;
    const updatedSteelSourceOption = {
      ...this.steelSourceOptionForm.value,
      countryNames: this.selectedCountries
    };

    this.steelSourceOptionService.editSteelSourceOption(this.steelSourceOptionId, updatedSteelSourceOption).pipe(
      catchError(error => {
        this.errors = {};  

        if (error.status === 400) {
          if (Array.isArray(error.error)) {
            error.error.forEach((errMessage: string) => {
              if (errMessage.includes('Title')) {
                this.errors.title = this.errors.title || [];
                this.errors.title.push(errMessage);
              } else if (errMessage.includes('Percentage')) {
                this.errors.percentage = this.errors.percentage || [];
                this.errors.percentage.push(errMessage);
              } else if (errMessage.includes('Coefficient')) {
                this.errors.coefficient = this.errors.coefficient || [];
                this.errors.coefficient.push(errMessage);
              } else if (errMessage.includes('ScenarioCategoryId')) {
                this.errors.scenarioCategoryId = this.errors.scenarioCategoryId || [];
                this.errors.scenarioCategoryId.push(errMessage);
              } else if (errMessage.includes('Description')) {
                this.errors.description = this.errors.description || [];
                this.errors.description.push(errMessage);
              } else {
                this.errors.general = this.errors.general || [];
                this.errors.general.push(errMessage);
              }
            });
          } else if (typeof error.error === 'string') {
            this.errors.general = [error.error];
          } else {
            this.toastr.error('An unexpected error occurred.');
          }
        } else {
          this.toastr.error('Failed to update recycling option.');
        }
        return [];
      })
    ).subscribe(
      response => {
        this.toastr.success('Steel Source Option updated successfully!');
        this.router.navigate(['/homeAdmin/v2/steelSourceOptions']);
      },
      error => {
        console.error('Error updating steel source option:', error);
      }
    ).add(() => {
      this.isSubmitting = false;
    });
  }
}